import { useDANGEROUSisChalkEmployee } from "@/utils/hooks/use-is-chalk-employee";
import dynamic from "next/dynamic";
import type { FC } from "react";

const LineageDrawer = dynamic(
  () => import("@/components/admin/LineageDrawer").then((module) => module.LineageDrawer),
  { ssr: false },
);

/**
 * Singleton mounted in NetworkingWrapper, alongside NetworkLogBootstrap. Hosts
 * the hidden LineageService debug pane's global bottom drawer; unlike the
 * network log there is no background capture to gate, so this only decides
 * whether the drawer (and the "Open lineage" admin-menu item that reveals it)
 * exist for this session at all.
 */
export const LineageBootstrap: FC = () => {
  const isChalkEmployee = useDANGEROUSisChalkEmployee();

  if (!isChalkEmployee) {
    return null;
  }

  return <LineageDrawer />;
};
